import React, { useState } from "react";
import { Button, Input, Space, Typography, Modal, Row, Col } from "antd";
import { useDispatch } from "react-redux";
import { BASE_URLS } from "../../../core/data/redux/apis/urls";
import Api from "../../../core/data/redux/utils/apiCall";
import Preloader from "../../../core/common/loader/preLoader";
import { toast } from "react-toastify";
import {
    getLanguageTranslations,
} from "../../../core/data/redux/languageSlice";

const { TextArea } = Input;


interface TransJsonModalProps {
    isJsonModalVisible: boolean;
    handleIsJsonModalVisible: (val: boolean) => void;
    languageId?: number;
}

const TransJsonModal: React.FC<TransJsonModalProps> = ({ isJsonModalVisible, handleIsJsonModalVisible, languageId }) => {

    const [jsonInput, setJsonInput] = useState("");
    const [isValid, setIsValid] = useState(true);
    const [isLoading, setIsLoading] = React.useState(false);
    const dispatch = useDispatch();
    // ✅ Validate JSON live as user types
    const validateJson = (value: string) => {
        try {
            JSON.parse(value);
            setIsValid(true);
        } catch (err: any) {
            setIsValid(false);
        }
    };

    // ✅ Handle change in textarea
    const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        const value = e.target.value;
        setJsonInput(value);
        if (value.trim()) validateJson(value);
        else {
            setIsValid(true);
        }
    };

    // ✅ Beautify / Format JSON
    const handleFormat = () => {
        try {
            const formatted = JSON.stringify(JSON.parse(jsonInput), null, 2);
            setJsonInput(formatted);
            setIsValid(true);
            toast.success("JSON formatted successfully!");
        } catch (err) {
            setIsValid(false);
            toast.error("Invalid JSON. Please fix it before formatting.");
        }
    };


    const handleSend = async () => {

        try {
            const formatted = JSON.stringify(JSON.parse(jsonInput), null, 2);
            setJsonInput(formatted);
            setIsLoading(true);
            const endPoint = `${BASE_URLS.BASE_URL}languages/import-lang-json`;
            const res = await Api.post(`${endPoint}`,
                { "language_id": languageId, "lang_json": JSON.parse(jsonInput) }
            );
            setIsLoading(false);
            toast.success("Translations imported successfully!");
            handleIsJsonModalVisible(false)
            setJsonInput("");
            setIsValid(true);
            setTimeout(() => {
                // Refresh translations after import
                dispatch(getLanguageTranslations({ languageId: languageId || "" }));
            }, 1500);

        } catch (err: any) {
            setIsValid(false);
            setIsLoading(false);
            toast.error(err?.response?.data?.message || "An error occurred. Please try again.");
        }
    };

    return (
        <>
            {isLoading && <Preloader />}
            <Modal
                title="Import Translations via JSON"
                open={isJsonModalVisible}
                footer={null}
                width={600}
                onCancel={() => handleIsJsonModalVisible(false)}
            >
                <div
                    style={{
                        justifyContent: "center",
                        background: "#f9f9f9",
                        padding: "40px",
                        marginTop: 40
                    }}
                >

                    <Row>
                        <Col md={24}>
                            <TextArea
                                rows={14}
                                value={jsonInput}
                                onChange={handleChange}
                                placeholder='Enter or paste JSON data here...'
                                style={{
                                    fontFamily: "monospace",
                                    marginTop: "15px",
                                    borderColor: !isValid ? "#ff4d4f" : undefined,
                                    background: "#fafafa",
                                }}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Space style={{ marginTop: "20px", justifyContent: "flex-end", width: "100%" }}>
                                <Button onClick={handleFormat}>Format JSON</Button>
                                <Button
                                    type="primary"
                                    loading={isLoading}
                                    onClick={handleSend}
                                    style={{
                                        backgroundColor: "#c0282c",
                                        border: "1px solid #c0282c",
                                        fontWeight: "500",
                                    }}
                                >
                                    Import
                                </Button>
                            </Space>
                        </Col>
                    </Row>
                </div>
            </Modal>
        </>
    );
};

export default TransJsonModal;
